import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon, LockIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroTestimonials } from '../data/testimonials';
import { HeroImage } from './HeroImage';
const features = ['12 Volúmenes', '6 Bonos', '+150 Ejercicios', 'Todos los Niveles', 'Acceso Inmediato'];
const stats = [{
  value: '+500',
  label: 'ENTRENADORES'
}, {
  value: '12+6',
  label: 'VOLÚMENES + BONOS'
}, {
  value: '4.9/5',
  label: 'VALORACIÓN ⭐'
}];
export function Hero() {
  return <header className="w-full bg-court-950 text-white" data-id="element-102" data-mp="xbpawzbp5obv">
      <div className="mx-auto flex min-h-[100svh] max-w-6xl flex-col px-5 pb-6 pt-4 sm:px-8 lg:min-h-0 lg:pb-14 lg:pt-10" data-id="element-103" data-mp="sb1a5lxo1t4g">
        <div className="flex flex-col items-center gap-1 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-104" data-mp="nczrh245jvti">
          <span className="font-display text-xs font-extrabold tracking-tight text-ball sm:text-sm" data-id="element-105" data-mp="3d2bhzk51cpsw">
            🎾 TENIS 360™ · CLASS ROOM
          </span>
          <span className="text-[9px] font-semibold uppercase tracking-[0.14em] text-court-600 sm:text-[11px] sm:tracking-[0.16em]" data-id="element-106" data-mp="3j8se7xjcfdo9">
            🎾 La eligen cientos de entrenadores en todo el mundo
          </span>
        </div>

        <div className="flex flex-1 flex-col lg:mt-12 lg:grid lg:flex-none lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-12" data-id="element-107" data-mp="399bahlnnj9ux">
          <div className="flex flex-1 flex-col lg:flex-none" data-id="element-108" data-mp="3e7l780p0yiin">
            <h1 className="mt-4 text-center font-display text-[26px] font-black leading-[1.05] tracking-tight sm:text-4xl lg:mt-0 lg:text-left lg:text-6xl" data-id="element-109" data-mp="30hrjjlp9a4ai">
              Planifica Todo Tu Año de Tenis{' '}
              <span className="text-ball" data-id="element-110" data-mp="2qkwml78msbyc">En Menos de 5 Minutos.</span>
            </h1>

            <div className="flex min-h-0 flex-1 items-center justify-center py-3 lg:hidden" data-id="element-111" data-mp="2vi56bc9fgo1p">
              <HeroImage className="max-h-[38svh] w-auto max-w-[86%] object-contain" data-id="element-112" data-mp="2hix0i0irehoj" />
            </div>

            <p className="text-center text-[13px] leading-relaxed text-court-600 sm:text-base lg:mt-6 lg:max-w-xl lg:text-left lg:text-lg" data-id="element-113" data-mp="2ll0ht5s40ghq">
              La biblia completa del entrenador de tenis: 12 volúmenes, 6 bonos estratégicos, +150
              ejercicios, herramientas de planificación y mucho más.{' '}
              <span className="font-semibold text-white" data-id="element-114" data-mp="id02omr47ymj">Todo ya hecho para ti.</span>
            </p>

            <ul className="mt-3 flex flex-wrap justify-center gap-x-3 gap-y-1.5 lg:mt-8 lg:justify-start lg:gap-x-5 lg:gap-y-3" data-id="element-115" data-mp="degd8cdbc4pf">
              {features.map(feature => <li key={feature} className="flex items-center gap-1.5 text-[11px] font-medium sm:text-sm" data-id="element-116" data-mp="161jal16969e3">
                  <CheckIcon className="h-3.5 w-3.5 text-ball sm:h-4 sm:w-4" strokeWidth={3} aria-hidden="true" data-id="element-117" data-mp="114kkqutmgolp" />
                  {feature}
                </li>)}
            </ul>

            <div className="mt-4 lg:mt-10" data-id="element-118" data-mp="3hpsgzbzpc357">
              <CtaButton href="#buy" size="hero" className="w-full sm:w-auto" data-id="element-119" data-mp="1x9kwertfdeju">
                🚀 Quiero Tenis 360 — Solo $19
              </CtaButton>
              <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[10px] text-court-600 sm:text-xs lg:mt-4 lg:justify-start lg:gap-x-5 lg:gap-y-2" data-id="element-120" data-mp="21bfy3xf9pty5">
                <span className="flex items-center gap-1.5" data-id="element-121" data-mp="2b1hk8jo292af">
                  <LockIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-122" data-mp="2g02jogvhnhxt" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-123" data-mp="2ky42r1swzh9a">
                  <ZapIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-124" data-mp="2l0q7ktof7int" /> Acceso
                  Inmediato
                </span>
                <span className="flex items-center gap-1.5" data-id="element-125" data-mp="2tyipm5lj14ew">
                  <ShieldCheckIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-126" data-mp="umhekdqvqnpe" />{' '}
                  Garantía de 7 Días
                </span>
              </p>
            </div>
          </div>

          <div className="hidden lg:block" data-id="element-127" data-mp="4b48dwosual1">
            <HeroImage className="mx-auto h-auto w-full max-w-lg object-contain" data-id="element-128" data-mp="49t2nrbsmsra" />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-court-800 sm:grid-cols-4 lg:mt-14" data-id="element-129" data-mp="3vhfew8ckw3jr">
          {stats.map(stat => <div key={stat.label} className="bg-court-950 px-4 py-5 text-center" data-id="element-130" data-mp="9a7c9dt1marf">
              <p className="font-display text-2xl font-black text-ball" data-id="element-131" data-mp="3hq0rlpbn1g6w">{stat.value}</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-court-600" data-id="element-132" data-mp="3cr7gu4nqk3af">
                {stat.label}
              </p>
            </div>)}
          <div className="bg-court-950 px-4 py-5 text-center" data-id="element-133" data-mp="3rhemtkwk3tu8">
            <p className="flex items-center justify-center gap-1.5 font-display text-2xl font-black text-ball" data-id="element-134" data-mp="3mp3lcdm63zzk">
              <GlobeIcon className="h-5 w-5" aria-hidden="true" data-id="element-135" data-mp="2yyhshtkqima5" />
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-court-600" data-id="element-136" data-mp="2u1hm1hjz3hii">
              En todo el mundo
            </p>
          </div>
        </div>

        <div className="mt-4 grid gap-4 md:grid-cols-3 lg:mt-10" data-id="element-137" data-mp="19gueou24mkvb">
          {heroTestimonials.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-court-800 bg-court-900 p-6" data-id="element-138" data-mp="zkr7h9sf3w1i">
              <p className="text-sm tracking-[0.1em] text-ball" aria-label="5 de 5 estrellas" data-id="element-139" data-mp="14h7xk9j6gkh8">
                ⭐⭐⭐⭐⭐
              </p>
              <blockquote className="mt-4 text-sm leading-relaxed text-white" data-id="element-140" data-mp="1x8rka3ezggnz">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5 text-xs text-court-600" data-id="element-141" data-mp="1j8747f0gcyy6">
                <span className="font-semibold text-white" data-id="element-142" data-mp="1n8r06f9ahwiq">{testimonial.name}</span> ·{' '}
                {testimonial.role} · {testimonial.location}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </header>;
}